import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../ApiEndpoint";



let initialState = {
    constactlistdata: [],
    isLoading: false,
    isError: null,
};

//post api
export const addconstactlist = createAsyncThunk("postconstactlist", async (data, { rejectWithValue }) => {
    const { endpoint, payload } = data;
    try {
        const res = await axios.post(BASE_URL + endpoint, payload,);
        // console.log(res, "resresres post");

        return res.data.contactlistdata;
    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

//Get api
export const getconstactlist = createAsyncThunk("getconstactlist", async ({ endpoint }, { rejectWithValue }) => {
    try {
        let res = await axios.get(BASE_URL + endpoint,);
        // console.log(res.data.contactlist ,"get list");
        return res.data.contactlist;
    } catch (Error) {
        return rejectWithValue(Error.response ? Error.response.data : Error.message);
    }
});

//delete api
export const deleteconstactlist = createAsyncThunk("deleteconstactlist", async (data, { rejectWithValue }) => {
    let { endpoint, uuid } = data;
    try {
        await axios.delete(BASE_URL + endpoint + uuid);
        // console.log(res, "delete res");
        return uuid;
    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});

//updata api 
export const updateconstactlist = createAsyncThunk("updateconstactlist", async (data, { rejectWithValue }) => {
    let { endpoint, uuid, payload } = data;
    try {
        const res = await axios.put(BASE_URL + endpoint + uuid, payload,);
        // console.log(res, "update res");
        return res.data.updatedlistdata;
    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message);
    }
});



//slice
export const contactlistdataSlice = createSlice({
    name: "contctlist",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            //post method
            .addCase(addconstactlist.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(addconstactlist.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action.payload; 
            })
            .addCase(addconstactlist.fulfilled, (state, action) => {
                state.isLoading = false;
                state.constactlistdata.push(action.payload);
            })
            //get method
            .addCase(getconstactlist.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(getconstactlist.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action.payload;
            })
            .addCase(getconstactlist.fulfilled, (state, action) => {
                state.isLoading = false;
                state.constactlistdata = action.payload;
            })
            //delete method
            .addCase(deleteconstactlist.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(deleteconstactlist.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action.payload;
            })
            .addCase(deleteconstactlist.fulfilled, (state, action) => {
                state.isLoading = false;
                state.constactlistdata = state.constactlistdata.filter((item) => item.uuid !== action.payload);
            })
            //updata method
            .addCase(updateconstactlist.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(updateconstactlist.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = action.payload;
            })
            .addCase(updateconstactlist.fulfilled, (state, action) => {
                state.isLoading = false;
                state.constactlistdata = state.constactlistdata.map((value) => value.uuid === action.payload.uuid ? action.payload : value);
            });

    },
});


export default contactlistdataSlice.reducer;